import React from "react";
import MNTPodsusedLogo from "../../Assets/Images/mnt-logo.png";
import StenjevecCupLogo from "../../Assets/Images/stenjevec-cup.png";

const reviewsData = [
  {
    id: 1,
    quote:
      "Odlično iskustvo s aplikacijom! Sve je radilo brzo, bez greške i jako lagana za korištenje. Brza podrška i dogovor bez komplikacija.",
    date: "28.07.2026.",
    tournamentName: "MNT Podsused",
    tournamentLogo: MNTPodsusedLogo,
  },
  {
    id: 2,
    quote:
      "Aplikacija nam je bila super za korištenje! Sve je pregledno, jednostavno i brzo, a posebno nam se svidjelo što su rezultati, raspored i ostale informacije dostupni na jednom mjestu. Sve je funkcioniralo bez problema i stvarno nam je olakšalo praćenje turnira. Sve pohvale!",
    date: "27.08.2026.",
    tournamentName: "Stenjevec CUP",
    tournamentLogo: StenjevecCupLogo,
  },
];

export default function FSHomeReviews() {
  return (
    <section className="scorify-reviews-section">
      <div className="scorify-section-header">
        <h3 className="scorify-section-title">RECENZIJE TURNIRA</h3>
      </div>

      <div className="scorify-reviews-grid">
        {reviewsData.map((review) => (
          <div className="scorify-review-card" key={review.id}>
            <div className="scorify-review-box">
              <i className="fi fi-rs-quote-right"></i>
              <p className="scorify-review-text">{review.quote}</p>
            </div>

            <div className="scorify-review-footer">
              <div className="scorify-tournament-info">
                <img
                  src={review.tournamentLogo}
                  alt={review.tournamentName}
                  className="scorify-tournament-logo"
                />
                <span className="scorify-tournament-name">
                  {review.tournamentName}
                </span>
              </div>
              <span className="scorify-review-date">{review.date}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
